import { render, staticRenderFns } from "./business-form.vue?vue&type=template&id=9a339b84&scoped=true"
import script from "./business-form.vue?vue&type=script&lang=js"
export * from "./business-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a339b84",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\WebBuild\\teamCity\\buildAgent\\work\\f0b2174a44415a20\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9a339b84')) {
      api.createRecord('9a339b84', component.options)
    } else {
      api.reload('9a339b84', component.options)
    }
    module.hot.accept("./business-form.vue?vue&type=template&id=9a339b84&scoped=true", function () {
      api.rerender('9a339b84', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/setting/business/components/business-form.vue"
export default component.exports